export default [
	{
		path: 'logs/logs',
		component: () => import('@/pages/Logs/Logs/Pages/Index'),
		name: 'Logs',
		meta: {
			path: '/logs/logs',
			pai: 'Logs',
			title: 'Admin - Logs',
			noCache: true,
			navigation: [{
				pagina: 'Home',
				class: 'ace-icon fa fa-home home-icon',
				active: false,
				url: '/'
			},
			{
				pagina: 'Logs',
				class: '',
				active: true,
				url: false
			}
			]
		}
	}
]